<!--半死半活-->
<template>
    <div id="proGeneric">
        <div v-if="skuLoading">
            <a-spin :spinning="skuLoading">
                <a-skeleton active />
            </a-spin>
        </div>

        <div v-else class="skupage" >
            <table-coms
                v-if="data.tableList != undefined"
                :tableData="SkuTableData"
                :cols="SkuTableColumns"
                :key="substr"
                :fixedNum="fixedNum"
                v-on:rederSub="GetrederSub"
                :checkboxFlag="true"
                v-on:selectRowData="getSelectDataTop"
                v-on:checkBoxSelectData="getBoxSelectData"
                :loading="parloading"
                ref="tablsRef"
                :setGmcuid="tableGmcuid"
                :subParAnsear="true"
                v-on:renderSearchVal="getredSearchVal"
                v-on:renderSortVal="getrenderSortVal"
                v-on:renderQueryVal="getrenderQueryVal"
                :MaxHeight="MaxHeight"
            >
                <template slot="topFunction">
                    <div
                            style="display: flex;justify-content: space-between;width: calc(100% - 10px);height: 35px;align-items: center;"
                    >
                        <div>
                <span style="float: left;">
                     <function-bar
                             @handleToolClick="handleToolClick"
                             :buttonsObj="data.functionBtn"
                     ></function-bar>
                </span>
                            <span style="float: left;margin-left: 4px;">
                 <a-icon type="search" style="margin-right: 4px;"/>
                     <a-select style="width: 180px" size="small" @change="skuTableTemplateData" v-model="parTableTemplateName" placeholder="Please select template">     
                                 <a-select-option value="all">all</a-select-option>
                  <a-select-option
                          :key="item"
                          :value="item"
                          v-for="item in parTableTemplateSelect"
                  >{{ item }}</a-select-option>
                  </a-select>
                </span>
                        </div>

                        <div>
                            <a-pagination
                                    :pageSizeOptions="pageSizeOptions"
                                    :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                                    size="small"
                                    :total="pagingTotal"
                                    v-model="currentVal"
                                    :pageSize.sync="pagingSize"
                                    @change="tableChangePage"
                                    @showSizeChange="onShowSizeChange"
                                    showSizeChanger

                            />
                        </div>
                    </div>
                </template>
            </table-coms>
        </div>
        <tabs-table
                v-if="data.tabs != undefined"
                :tabsData="data.tabs"
                :targetUID="targetUID"
                :showTitleValue="showTitleValue"
                :parTabelEditVerSion = "parTabelEditVerSion"
                :tabsActive="tabsActive"
                ref="tabsTable"
                 :notShowEditPageSaveBtn="notShowEditPageSaveBtn"
        ></tabs-table>
        <edit-from
                :QueryUpdatas="QueryUpdatas"
                :visible="eddvisible"
                v-on:cancelModalVisible="GETcancelModalVisible"
                :apiType="apiType"
        ></edit-from>


        <!--添加project Generic -->
        <a-modal
                title="Create Generic Extension"
                :visible="addProGenericVis"
                @cancel="() => (addProGenericVis = !addProGenericVis)"
        >
            <template slot="footer">
                <a-button type="danger" size="small" @click="proGenericReset">Reset</a-button>
                <a-button type="primary" size="small" @click="addProGenericSave">Save</a-button>
            </template>

            <a-form :form="proGenerForm">
                <a-form-item label="Extension Type" v-bind="formItemLayout">
                    <a-radio-group
                            size="small"
                            @change="extenionTypeChange"
                            v-decorator="[
                              'geType',
                              {
                                  initialValue: 'O' ,
                                  rules: [{ required: true, message: $t('publicLang.Required')}]
                              },
                            ]">
                        <a-radio value="O">Organization</a-radio>
                        <a-radio value="P">Project</a-radio>
                        <a-radio value="U">User</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="Project" v-bind="formItemLayout" v-if="ifProjectType">
                    <a-select
                            allowClear
                            size="small"
                            style="width: 100%"
                            v-decorator="[
                              'projectCode',
                              {
                                  rules: [{ required: true, message: $t('publicLang.Required')}]
                              },
                            ]">
                        <a-select-option v-for="item in proGenericSelectData.projectCodeList" :value="item.projectCode">{{item.projectCode}} - {{item.displayName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="User" v-bind="formItemLayout" v-if="ifUserType">
                    <a-select
                            show-search 
                             option-filter-prop="children" 
                             :filter-option="filterOption"
                            allowClear
                            size="small"
                            style="width: 100%"
                            v-decorator="[
                              'loginAccount',
                              {
                                  rules: [{ required: true, message: $t('publicLang.Required')}]
                              },
                            ]">
                        <a-select-option  :label="item.displayName"   v-for="item in userGenericSelectData.userList" :key="item.loginAccountKey" :value="item.loginAccountValue">{{item.loginAccountValue}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Module" v-bind="formItemLayout">
                    <a-cascader
                       allowClear
                       size="small"
                       :fieldNames="{
                          label: 'moduleCode',
                          value: 'key',
                          children: 'children'
                        }"
                        :options="proGenericSelectData.projectModuleList"
                        expandTrigger="hover"
                        @change="proGenericChange($event,'module')"
                        :placeholder="$t('publicLang.PleaseSelect')"
                         v-decorator="[
                              'subModuleCode',
                                  {
                                      rules: [{ required: true, message: $t('publicLang.Required')}]
                                  },
                            ]"
                    />
                </a-form-item>
                <a-form-item label="Function Code" v-bind="formItemLayout">
                    <a-select
                        allowClear
                        size="small"
                        style="width: 100%"
                        @change="proGenericChange($event,'func')"
                        v-decorator="[
                          'funcCode',
                              {
                                  rules: [{ required: true, message: $t('publicLang.Required')}]
                              },
                        ]">
                        <a-select-option v-for="item in proGenericSelectData.projectFunctionList" :value="item.functionKey">{{item.functionValue}}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="System Generic Name" v-bind="formItemLayout" v-if="ifsystemGenericName">
                    <a-select
                        size="small"
                        style="width: 100%"
                        allowClear
                        v-decorator="[
                          'gmcUid',
                              {
                                  rules: [{ required: true, message: $t('publicLang.Required')}]
                                  },
                            ]" >
                        <a-select-option v-for="item in sysNameSelect" :value="item.gmcUid">{{item.genericName}}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>

        <a-drawer
                title="Generic Extension"
                placement="right"
                :visible="proHeaderVis"
                width="90%"
                @close="() => (proHeaderVis = !proHeaderVis)"
        >

            <a-tabs class="card-container" :animated="animated" tab-position="left">
                <a-tab-pane tab="Header" key="1">
                    <pro-header :proGenericHeaderInfo="proGenericHeaderInfo"></pro-header>
                </a-tab-pane>
                <a-tab-pane :tab="$t('generic.PageProperty')" key="2">
                    <page-property :proGenericHeaderInfo="proGenericHeaderInfo" :targetProgenericUid="targetProgenericUid"></page-property>
                </a-tab-pane>
                <a-tab-pane tab="Behavior" key="3">
                    <pro-behavior :targetProgenericUid="targetProgenericUid"></pro-behavior>
                </a-tab-pane>
                <a-tab-pane tab="Tab" key="4">
                    <tab-coms :targetProgenericUid="targetProgenericUid"></tab-coms>
                </a-tab-pane>
            </a-tabs>
        </a-drawer>



    </div>
</template>
<script>
    import functionBar from "./components/functionBar.vue";
    import tabsTable from "./components/tabsTable.vue";
    import editFrom from "./components/editFrom.vue";

    import tableComs from "../com/tableComs.vue";
    import andOr from "../com/queryBuilder/components/AndOR.vue";
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import { mapState } from "vuex";
    import axios from "axios";
    import cookie from "../../api/cookie";
    import moment from "moment";

    import proHeader from "./proGeneric/proHeader.vue";
    import pageProperty from "./proGeneric/pageProperty.vue";
    import proBehavior from "./proGeneric/behavior.vue";
    import tabComs from "./proGeneric/tabComs.vue";

    export default {
        components: {
            tableComs,
            functionBar,
            tabsTable,
            editFrom,
            proHeader,
            pageProperty,
            proBehavior,
            tabComs
        },

        computed: {
            ...mapState(["FUNAPI"]),
            ...mapState(["lang"]),

        },
        data() {
            return {
                  notShowEditPageSaveBtn : false,
                sysNameSelect: [], //  System Generic Name下拉数据
//                projecGeneric start
                ifProjectType: false, //如果是Project 切换弹窗 
                ifUserType: false, //如果是User 切换弹窗
                addProGenericVis: false, // 添加generic Vis
                proGenerForm:  this.$form.createForm(this), // add project generic from
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                proGenericSelectData: {},
                userGenericSelectData: {},
                ifsystemGenericName: false,
                proHeaderVis: false,
                animated: false, // 关关闭切换动画
                proGenericHeaderInfo: {}, // header info
                targetProgenericUid: null, // 点击当前的uid
//                projecGeneric end

                SkuTableColumns: [],
                tabsActive: '0',
                showTitleValue: [],
                lookupParams: {},
                pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                parTableTemplateSelect:[],
                parTabelEditVerSion: null,
                skuLoading: true,
                options: {
                    condition: [],
                    fieldNameSel: []
                },
                isFirst: true,
                fixedNum: 0, // 需要固定
                substr: 0, // 更新组件下标
                targetUID: null, // 点击表格转给弹窗uid
                tableGmcuid: "", // 后台返回GMUID
                pagingTotal: 0, // 总数
                pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
                currentVal: 1, // 页数
                pageInfoType: "", // 分页查询条件
                customStyle: "border: 0;overflow: hidden",
                pb_selectList: [], // 表格check选中
                parloading: true, // 夫加载
                eddvisible: false,
                QueryUpdatas: {},
                apiType: "",
                funApi: "",
                strsub: 1,
                importVisible: false,
                TitleSearchVal: [], // 表格title search 条件
                importparams: {}, // 传个iport 参数
                manualParams: {}, // 转个manual 参数
                bathUpdatparams: {},
                initRenderFnSearchParamsArr: {
                    SortValArr: [],
                    titleSearchArr: [],
                    andvanSearchArr: {}
                },
                MaxHeight: 0,
                parTableTemplateName: undefined,
                SkuTableData: [],
                isBtnajax: false,
                data: {}
            };
        },
//  inject: ["reload"],
        created() {
            this.MaxHeight = document.body.clientHeight - 160;
            this.data = {} // 表格数据
            this.init("empty_temp");
            let params = {
                lang: this.lang
            };
            ajax.get(api.GETUSERMENU, params).then(res=>{
                this.proGenericSelectData.projectCodeList = res.data.projectCodeList
            });
            ajax.get(api.GETLOGINACCOUNTDATA).then(res => {
                this.userGenericSelectData.userList = res.data;
            });
            ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
                this.proGenericSelectData.projectFunctionList= res.data;
            });
            ajax.get(api.GETMODULEDROPDATA).then(res => {
                this.proGenericSelectData.projectModuleList = res.data
            });
        },
        /* 解决重复加载
        watch: {
            $route(val) {
                if(val.path == "/generic"){
                    return
                }
                this.init();
            },
            lang() {
                this.init();
            }
        },
        */
        methods: {
            cleardata(){
                this.data = []
                this.init()
            },
            extenionTypeChange(v){
                if (v.target.value == 'P'){
                    this.ifProjectType = true;
                    this.ifUserType = false;
                }else if(v.target.value == 'U'){
                    this.ifProjectType = false;
                    this.ifUserType = true;
                }else {
                    this.ifProjectType = false;
                    this.ifUserType = false;
                }
            },
            proGenericReset(){
                this.ifsystemGenericName = false
                this.proGenerForm.resetFields()
            },
            proGenericChange(v,item){
                this.proGenerForm.setFieldsValue({'gmcUid': null})
                if(item == 'module'){
                    if(v == undefined || v.length == 0){
                        this.ifsystemGenericName = false
                        this.sysNameSelect = []
                        return
                    }
                    if(this.proGenerForm.getFieldValue('funcCode')){
                        let params = {
                            "funcCode": this.proGenerForm.getFieldValue('funcCode'),
                            "subModuleCode": v[1]
                        }
                        this.ajaxSysname(params)
                    }
                }else{
                    if(v == undefined){
                        this.ifsystemGenericName = false
                        this.sysNameSelect = []
                        return
                    }
                    if(this.proGenerForm.getFieldValue('subModuleCode') != undefined && this.proGenerForm.getFieldValue('subModuleCode').length > 0){
                        let params = {
                            "funcCode":v,
                            "subModuleCode":this.proGenerForm.getFieldValue('subModuleCode')[1]
                        }
                        this.ajaxSysname(params)
                    }else{
                        this.ifsystemGenericName = false
                        this.sysNameSelect = []
                    }
                }
            },
            ajaxSysname(params){
                ajax.post(api.GENERICEXTGENERICSTMGENERIC,params).then(res=>{
                    this.sysNameSelect= res.data
                    this.ifsystemGenericName = true
                })
            },
            addProGenericSave(){
                this.proGenerForm.validateFields((err, values) => {
                    if (!err) {
                        values.subModuleCode =  values.subModuleCode[1]
                        values.uid = this.proGenerForm.uid;
                        this.proGenerForm.uid = null;
                        ajax.post(api.GENERICEXTGENERICCREATIONORCLONE,values).then(res=>{
                            if(res.code == 200){
                                this.addProGenericVis = false
                                this.$message.success(res.msg)
                                this.init()
                            }else{
                                this.$customMessage.warning(res.msg)
                            }
                        })
                        /* Sour
                        ajax.post(api.GENERICEXTGENERICCREATION,values).then(res=>{
                            if(res.code == 200){
                                this.addProGenericVis = false
                                this.$message.success(res.msg)
                                this.init()
                            }else{
                                this.$customMessage.warning(res.msg)
                            }
                        })
                        */
                    }
                });
            },

            skuTableTemplateData(val){
                this.clearImportUids()
                 this.parTableTemplateName  = val           
                this.parloading = true;
                let jsonArray = {};
                jsonArray.gmcUid = this.tableGmcuid;
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFn();
            },
            getTemplateName(){
                ajax.get(api.ADVANCETEMPLATE, { gmcUid: this.tableGmcuid }).then(res => {
                    this.parTableTemplateSelect = res.data
                    // if(this.parTableTemplateSelect.length> 0){
                    //     this.parTableTemplateName = this.parTableTemplateSelect[0]
                    // }
                });
            },
            //      generatelocation 返回的值刷新init
            getGeneratelocation() {
                this.init();
            },
            //      sort
            getrenderSortVal(paramsArr) {
                this.parloading = true;
                this.pageInfoType = "sort";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.SortValArr = paramsArr;
                this.initRenderFn();
            },
            //      titleSearch
            getredSearchVal(val) {
                this.TitleSearchVal = val;
                let scParams = [];
                let tt = JSON.parse(JSON.stringify(val))
                tt.forEach((v, i) => {
                    if(v.type == "Datetime"){
                        if(v.serVal){
                            v.serVal = moment(v.serVal).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                    if (v.type == "Date") {
                        if(v.serVal){
                            v.serVal =  moment(v.serVal).format('YYYY-MM-DD')
                        }
                    }
                    if (v.serVal) {
                        if( Array.isArray(v.serVal)){
                            for(let i in v.serVal){
                                scParams.push({ key: v.uid, value: v.serVal[i] });
                            }
                        }else{
                            scParams.push({ key: v.uid, value: v.serVal });

                        }
                    }
                });
                this.pageInfoType = "tle";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.titleSearchArr = scParams;
                this.initRenderFnSearchParamsArr.andvanSearchArr = [];
                this.initRenderFn();
            },

            //      query filter提交
            getrenderQueryVal(item) {
                this.clearImportUids()
                this.parloading = true;
                let jsonArray = item.query;
                jsonArray.gmcUid = this.tableGmcuid;
                let templateName  = item.tml
                if(templateName != undefined && templateName != null){
                  this.parTableTemplateName  = templateName 
                }          
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFnSearchParamsArr.titleSearchArr = [];
                this.initRenderFn();
            },
            //      选择条数
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.initRenderFn();
            },
            //      表格分页
            tableChangePage(current) {
                this.currentVal = current;
                this.initRenderFn();
            },
            //      何在一起三个
             initRenderFn() {
                this.$nextTick(()=>{
                    this.parloading = true;
                    let params = {
                        functionUid: this.$route.query.funcUid,
                        gmcUid: this.tableGmcuid,
                        language: this.lang,
                        userUid: this.$route.query.userUid,
                        paging: {
                            pageNum: this.currentVal,
                            pageSize: this.pagingSize
                        }
                    };
                    //                sesstion 有importUid 加上这个参数
                    let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                    let topMenuActive = sessionStorage.getItem("menuActive")
                    for(let i in topMenu){
                        if(topMenu[i].key == topMenuActive){
                            if(topMenu[i].importUids){
                                params.importUids = topMenu[i].importUids
                            }
                        }
                    }

                    if (this.pageInfoType == "sort") {
                        params.userSortDtos = this.initRenderFnSearchParamsArr.SortValArr;
                    } else if (this.pageInfoType == "tle") {
                        params.columnSearch = this.initRenderFnSearchParamsArr.titleSearchArr;
                    } else if (this.pageInfoType == "qf") {
                        params.userSqlDto = this.initRenderFnSearchParamsArr.andvanSearchArr;
                        params.userSqlDto.template = this.parTableTemplateName;
                    }
                    ajax.post(api.SKUS, params).then(res => {
                        if (res.code == 200) {
  				            	this.parloading = false;
                               if(res.data.tableList.paging != null){
                                  this.pagingTotal = res.data.tableList.paging.totalPageSize;
                               }   																						
							   this.substr = this.substr + 1;      
                               this.data.tableList.data = res.data.tableList.data;
                               this.data.tableList.columns = res.data.tableList.columns;
                               this.SkuTableData = res.data.tableList.data;
                                this.SkuTableColumns = res.data.tableList.columns
                        } else {
                            this.$customMessage.warning(res.msg, 3);
                        }
                    });
                })
            },
            //      获取初始化数据
            init(type) {
                   this.initRenderFnSearchParamsArr.SortValArr= []
                      this.initRenderFnSearchParamsArr.titleSearchArr = []
                      this.initRenderFnSearchParamsArr.andvanSearchArr = {}
			
			
                // this.parTableTemplateName = undefined
                if (type == "editok") {
                    this.initRenderFn();
                }
                this.skuLoading = true;
                this.funApi = this.$route.query.funApi;
                if (this.funApi == "") {
                    return;
                }
                this.currentVal = 1;
                let params = {
                    userUid: this.$route.query.userUid,
                    functionUid: this.$route.query.funcUid,
                    language: this.lang,
                    pageNum: this.currentVal,
                    pageSize: this.pagingSize
                };

                if( "empty_temp" != type ){
                        let templateName = this.parTableTemplateName;
                        if(templateName == null || templateName == undefined){
                             this.parTableTemplateName = type
                            templateName = type;
                        }
                         this.pageInfoType = "qf"
                         params.userSqlDto = {};
                         params.userSqlDto.template = templateName;
                         params.isLoadAllConfig = false;
                }else{
                        this.parTableTemplateName = undefined
                }


                this.pb_selectList = [];
                if(params.userUid == undefined && params.functionUid == undefined){
//            this.$customMessage.warning(this.$t('publicLang.IncorrectConfiguration'), 3)
                }
                //                sesstion 有importUid 加上这个参数
                let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                let topMenuActive = sessionStorage.getItem("menuActive")
                for(let i in topMenu){
                    if(topMenu[i].key == topMenuActive){
                        if(topMenu[i].importUids){
                            params.importUids = topMenu[i].importUids
                        }
                    }
                }
                ajax.get(this.funApi, params).then(res => {
                    this.skuLoading = false;
                    if (res.code == 200) {
                        if(res.data.tableList.paging != null){
                            this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        }
                        this.parloading = false;
                        this.substr = this.substr + 1;
                        this.SkuTableColumns = res.data.tableList.columns
                        this.SkuTableData = res.data.tableList.data


                       if( "empty_temp" == type ){
                             this.data = res.data;
                             this.tableGmcuid = res.data.gmcUid;
                             this.getTemplateName()
                            for(let i in this.SkuTableColumns){
                                if(this.SkuTableColumns[i].type == 'DROP'){
                                    this.SkuTableColumns[i].serVal = []
                                }
                             }

                           
                            for (let i in this.data.functionBtn) {
                                 let tt = this.data.functionBtn[i].children;
                                 for (let j in tt) {
                                     if (tt[j].code == "BTN_EDIT") {
                                         tt[j].editFlag = "1";

                                     }
                                 }
                             }
                          
                             for(let i in this.data.tabs){
                                 if( this.data.tabs[i].loadable == '1'){
                                     this.tabsActive = i
                                 }
                             }
                         }
                    }
                });
            },
            //            清楚缓存中的ImportUids
            clearImportUids(){
                let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                let topMenuActive = sessionStorage.getItem("menuActive")
                for(let i in topMenu){
                    if(topMenu[i].key == topMenuActive){
                        if(topMenu[i].importUids){
                            delete topMenu[i].importUids
                        }
                    }
                }
                sessionStorage.setItem("menu", JSON.stringify(topMenu));
            },
            //    操作固定width 需要重新渲染组件
            GetrederSub(val) {
                this.fixedNum = val;
                this.substr = this.substr + 1;
            },
            //      点击表格组件返回的当条数据，传给弹窗
            getSelectDataTop(val) {
                this.targetProgenericUid = val.uid
                ajax.get(api.GENERICEXTGENERICGEEXTHEADER,{geExtHeaderUid: val.uid}).then(res=>{
                    this.proGenericHeaderInfo = res.data
                    this.proHeaderVis = true
                })
            },
            //      获取表格checkbox
            getBoxSelectData(val) {
                this.pb_selectList = val;
            },
            //      功能
            handleToolClick(val) {
                if (val.code === "BTN_UPDATE") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                        return;
                    }
                    let that = this;
                    this.$customConfirm({
                        title: that.$t('publicLang.AreUpadte'),
                        okText: that.$t('publicLang.Confirm'),
                        cancelText: that.$t('publicLang.Cancel'),
                        content: "",
                        onOk() {
                            that.isBtnajax = true
                            let deleteData = that.pb_selectList;
                            let paramsData = [];
                            for (let index in deleteData) {
                                if (deleteData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = deleteData[index].uid;
                                    paramsData.push(paramsObj);
                                    paramsData.push({
                                        key: "version",
                                        value: deleteData[index].version
                                    });
                                }
                            }
                            let params = {
                                behrUid: val.btnUid,
                                userUid: that.$route.query.userUid,
                                functionUid: that.$route.query.funcUid,
                                gmcUid: val.pattern.gmcUid,
                                params: paramsData,
                                type: "update",
                                language: that.lang
                            };

                            ajax.post(api.UPDATE, params).then(res => {
                                that.isBtnajax = false
                                if (res.code === 200) {
                                    that.$message.success(res.msg);
                                    that.initRenderFn();
                                    that.pb_selectList = [];
                                } else {
                                    that.$customConfirm({
                                        title: res.msg,
                                        okText: "Yes",
                                        okType: "confirm",
                                        cancelText: "No",
                                        onOk() {
                                            that.initRenderFn();
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                if (val.code == "BTN_REFRESH") {
                    this.clearImportUids()
                    this.init("all");
                }
                //        添加
                if (val.code === "BTN_ADD") {
                    this.addProGenericVis = true
                    this.proGenericReset()
                }
                //        删除
                if (val.code === "BTN_DELETE") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    if(val.pattern.custPage == "Cron"){
                        let that = this
                        this.$customConfirm({
                            title: this.$t('pubGicSet.AreyoudeleTask'),
                            okText: this.$t('publicLang.Confirm'),
                            cancelText: this.$t('publicLang.Cancel'),
                            content: "",
                            onOk(){
                                that.isBtnajax = true
                                let deleteData = that.pb_selectList;
                                let paramsData = [];
                                for (let index in deleteData) {
                                    paramsData.push(deleteData[index].uid)
                                }
                                ajax.post(api.DELETEJOBSCHEDULE,{uids: paramsData}).then(res=>{
                                    that.isBtnajax = false
                                    that.initRenderFn();
                                    if (res.code === 200) {
                                      that.$message.success(that.$t("publicLang.DeleteSuccess"));
                                    }else{
                                        that.$customMessage.error(res.msg);
                                    }
                                })
                            }
                        })
                        return
                    }
                    let tt = [];
                    for (let ii in this.pb_selectList) {
                        if (!this.pb_selectList[ii].deletable) {
                            tt.push(this.pb_selectList[ii].key + 1);
                        }
                    }
                    if (tt.length > 0) {
                        let cc;
                        cc = tt.join(",");
                        this.$customMessage.warning(
                            "[Row#"+cc+']'+this.$t('publicLang.NotAllowtodeleteCancel'),
                            5
                        );
                        return;
                    }
                    let that = this;
                    this.$customConfirm({
                        title: this.$t('pubGicSet.AreyoudeleTask'),
                        okText: this.$t('publicLang.Confirm'),
                        cancelText: this.$t('publicLang.Cancel'),
                        content: "",
                        onOk() {
                            that.isBtnajax = true
                            let deleteData = that.pb_selectList;
                            let paramsData = [];
                            for (let index in deleteData) {
                                if (deleteData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = deleteData[index].uid;
                                    paramsData.push(paramsObj);
                                    paramsData.push({
                                        key: "version",
                                        value: deleteData[index].version
                                    });
                                }
                            }
                            let params = {
                                behrUid: val.btnUid,
                                userUid: that.$route.query.userUid,
                                functionUid: that.$route.query.funcUid,
                                gmcUid: val.pattern.gmcUid,
                                params: paramsData,
                                type: "delete",
                                language: that.lang
                            };

                            ajax.post(api.UPDATE, params).then(res => {
                                that.isBtnajax = false
                                if (res.code === 200) {
                                  that.pb_selectList = [];
                                  that.initRenderFn();
                                  that.$message.success(that.$t("publicLang.DeleteSuccess"));
                                } else {
                                  that.$customMessage.error(res.msg);
                                }
                            });
                        }
                    });
                }
                //        copy
                if (val.code == "BTN_COPY") {
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    } else {
                        this.QueryUpdatas = {};
                        let paramsData = [];
                        let dataValues = this.pb_selectList[0];
                        let params = {
                            gmcUid: val.pattern.gmcUid,
                            dataUid: dataValues.uid,
                            language: this.lang
                        };
                        this.eddvisible = true;
                        ajax.post(api.POPUP, params).then(res => {
                            this.QueryUpdatas = res;
                            this.QueryUpdatas.behrUid = val.btnUid;
                            this.QueryUpdatas.lookupCode = val.code;
                            this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                            this.apiType = "edit";
                        });
                    }
                }
                //        import
                if (val.code == "BTN_IMPORT") {
                    let params = {
                        btnUid: val.btnUid,
                        userUid: this.$route.query.userUid,
                        language: this.lang,
                        fieldMapUid: val.mapUid,
                        importTitle: val.name,
                        isMove: val.pattern.custPage
                    };
                    if(val.type == "POPUP" && val.viewType == "SINGLE"){
                        let specialModule = []
                        if(this.data.tableList.info == "GR_HEADER"){
                            if(this.pb_selectList.length < 1){
                                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                                return
                            }
                            specialModule = this.pb_selectList
                        }else{
                            if (this.pb_selectList.length != 1){
                                this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                                return;
                            }
                        }

                        this.QueryUpdatas = {};
                        let paramsData = [];
                        let dataValues = this.pb_selectList[0];
                        params = {
                            gmcUid: val.pattern.gmcUid,
                            importForView: {
                                dataUid: dataValues.uid,
                                gmcUid: this.tableGmcuid,
                                mapUid: val.mapUid
                            },
                            language: this.lang
                        }
                        this.isBtnajax = true
                        ajax.post(api.POPUP, params).then(res => {
                            this.isBtnajax = false
                            this.QueryUpdatas = res;
                            this.QueryUpdatas.uid = dataValues.uid
                            this.QueryUpdatas.specialModule = specialModule
                            this.QueryUpdatas.behrUid = val.btnUid;
                            this.QueryUpdatas.fieldMapUid = val.mapUid;
                            this.QueryUpdatas.toGmcuid = val.pattern.gmcUid;
                            this.QueryUpdatas.lookupCode = val.code;
                            this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                            this.QueryUpdatas.type = 'To'
                            if(val.pattern.action == "scanin"){
                                this.QueryUpdatas.zdSave = true
                            }
                            this.apiType = "edit";
                            this.eddvisible = true;
                        });
                        return
                    }

                    if (val.type == "POPUP" && val.viewType == "LIST") {
                        params.importType = "DB";
                        params.gmcUid = val.pattern.gmcUid;
                        params.partTableUid = this.tableGmcuid;
                    } else if (val.type == "File" && val.viewType == "EXCEL") {
                        params.importType = "excel";
                        params.gmcUid = val.pattern.gmcUid;
                    } else {
                        this.$customMessage.warning(this.$t('publicLang.SystemAdministrator'), 3);
                        return;
                    }
                    this.importparams = params;
                    this.importVisible = true;
                }
                //                pdf
                if (val.code == "BTN_PRINT") {
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        return;
                    }
                    let ajaxurl = ajax.ajaxUrl();
                    this.isBtnajax = true
                    let that = this
                    axios.post(ajaxurl + api.PRINTPREVIEW, {
                            gmcUid: this.tableGmcuid,
                            uid: this.pb_selectList[0].uid,
                            btnName: val.name,
                            btnUid: val.btnUid
                        }, {
                        headers: {
                            Authorization: cookie.getBearerToken()
                        },
                        responseType: "blob" //二进制流
                    }).then(function(res) {
                            that.pubPdfMsgfn(res)
                    });
                }
                //        export
                if (val.code == "BTN_EXPORT") {
                    if (val.patternType == "EXT") {
                        let ajaxurl = ajax.ajaxUrl();
                        this.isBtnajax = true
                        let that = this
                        axios.get(ajaxurl + val.externalApi, {
                            params: {
                                btnUid: val.btnUid,
                                language: this.lang
                            },
                            headers: {
                                Authorization: cookie.getBearerToken()
                            },
                            responseType: "blob" //二进制流
                        })
                            .then(function(data) {
                                that.isBtnajax = false
                                if (!data) {
                                    return;
                                }
                                var blob = new Blob([data.data], {
                                    type:
                                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                                });
                                var url = window.URL.createObjectURL(blob);
                                var aLink = document.createElement("a");
                                aLink.style.display = "none";
                                aLink.href = url;
                                aLink.setAttribute("download", "excel.xlsx");
                                document.body.appendChild(aLink);
                                aLink.click();
                                document.body.removeChild(aLink); //下载完成移除元素
                                window.URL.revokeObjectURL(url); //释放掉blob对象
                            })
                            .catch(function(error) {
                                alert(error);
                            });
                    }
                    if(val.viewType == "EXCEL"){
                        let params = {
                            gmcUid: this.tableGmcuid,
                            language: this.lang,
                            export: 'excel',
                        }
                        let arr = this.initRenderFnSearchParamsArr.andvanSearchArr // adv search
                        let tileArr = this.initRenderFnSearchParamsArr.titleSearchArr // title Search
                        if(tileArr.length > 0 ){
                            params.columnSearch = tileArr
                        }else{
                            if(!(arr instanceof Array)){
                               if(JSON.stringify(arr) !="{}"){
                                    params.userSqlDto = arr
                                }else if(this.parTableTemplateName != undefined && this.parTableTemplateName != null){                                
                                   params.userSqlDto = {};
                                   params.userSqlDto.gmcUid = this.tableGmcuid
                                   params.userSqlDto.template = this.parTableTemplateName                  
                               }
                            }
                        }
                        let ajaxurl = ajax.ajaxUrl();
                        this.isBtnajax = true
                        let that = this
                        ajax.exportExcel(ajaxurl+api.SKUS,params).then(data=>{
                            that.isBtnajax = false
                            if (!data) {
                                return;
                            }
                            var blob = new Blob([data.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            });
                            var url = window.URL.createObjectURL(blob);
                            var aLink = document.createElement("a");
                            aLink.style.display = "none";
                            aLink.href = url;
                            aLink.setAttribute("download", "excel.xlsx");
                            document.body.appendChild(aLink);
                            aLink.click();
                            document.body.removeChild(aLink); //下载完成移除元素
                            window.URL.revokeObjectURL(url); //释放掉blob对象
                        })
                    }
                }
//      save
                if (val.code == "BTN_SAVE") {
                    if (val.type == "BUTTON" && val.patternType == "EXT") {
                        if(val.externalApi == '/generic/extGeneric/AddOrClone'){
                            // 调用接口，将相关数据查出来

                            let paramsData = [];
                            if(this.pb_selectList.length == 1){
                                let SaveData = this.pb_selectList;
                                let patterParams = val.pattern.params;
                                for (let index in SaveData) {
                                    if (SaveData[index].uid != "") {
                                        let paramsObj = {};
                                        paramsObj.key = "uid";
                                        paramsObj.value = SaveData[index].uid;
                                        paramsData.push(paramsObj);
                                    }
                                }
                                let params = {
                                    behrUid: val.btnUid,
                                    userUid: this.$route.query.userUid,
                                    functionUid: this.$route.query.funcUid,
                                    gmcUid: val.pattern.gmcUid,
                                    params: paramsData,
                                    language: this.lang
                                };

                                // 查询出旧记录的数据
                              ajax.post('/generic/exGeneric/getSetting', params ).then(res => {
                                if (res.code == 200) {
                                  try{
                                    var sourInstance = JSON.parse(res.msg);
                                    // 将相关的数据源放到form表单之中
                                    this.addProGenericVis = true
                                    // 打开对应的界面
                                    if (sourInstance.geType == 'P'){
                                      this.ifProjectType = true;
                                      this.ifUserType = false;
                                    }else if(sourInstance.geType == 'U'){
                                      this.ifProjectType = false;
                                      this.ifUserType = true;
                                    }else {
                                      this.ifProjectType = false;
                                      this.ifUserType = false;
                                    }
                                    //设置System Generic Name的状态  (如果System Generic Name不为空，打开)
                                    this.ifsystemGenericName = sourInstance.gmcFlag;
                                    let params = {
                                      "funcCode":sourInstance.funcCode,
                                      "subModuleCode":sourInstance.subModuleCode[1]
                                    }
                                    this.ajaxSysname(params);
                                    // 设置相关的参数
                                    this.$nextTick(() => {
                                      this.proGenerForm.setFieldsValue({funcCode: sourInstance.funcCode});
                                      this.proGenerForm.setFieldsValue({subModuleCode: sourInstance.subModuleCode})
                                      this.proGenerForm.setFieldsValue({geType: sourInstance.geType});
                                      this.proGenerForm.setFieldsValue({projectCode: sourInstance.projectCode});
                                      this.proGenerForm.setFieldsValue({gmcUid: sourInstance.gmcUid});
                                      this.proGenerForm.uid = sourInstance.uid;
                                    })
                                  }catch (error){
                                    console.error('Failed to parse source instance data:', error);
                                    this.$customMessage.error('Data parsing error');
                                  }
                                } else {
                                  this.$customMessage.warning(res.msg)
                                }
                              });
                            }else if(this.pb_selectList.length < 1){
                              this.$customMessage.warning("Please select one record at least.", 5);
                              return;
                            }else {
                              this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3);
                              return;
                            }
                        } else {
                            let paramsData = [];
                            if (val.pattern.params.length > 0) {
                                if (this.pb_selectList.length < 1) {
                                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                                    return;
                                }
                                let SaveData = this.pb_selectList;
                                let patterParams = val.pattern.params;
                                for (let index in SaveData) {
                                    if (SaveData[index].uid != "") {
                                        let paramsObj = {};
                                        paramsObj.key = "uid";
                                        paramsObj.value = SaveData[index].uid;
                                        paramsData.push(paramsObj);
                                    }
                                }
                            }
                            let params = {
                                behrUid: val.btnUid,
                                userUid: this.$route.query.userUid,
                                functionUid: this.$route.query.funcUid,
                                gmcUid: val.pattern.gmcUid,
                                params: paramsData,
                                language: this.lang
                            };
                            let that = this
                            if(val.pattern.custPage === 'VehicleInactive' || val.pattern.custPage === 'VehicleActive'){
                                this.$customConfirm({
                                    title: this.$t('processActionMsg'),
                                    okText: this.$t('publicLang.Confirm'),
                                    okType: 'confirm',
                                    cancelText: this.$t('publicLang.Cancel'),
                                    onOk() {
                                        ajax.post(val.externalApi, params).then(res => {
                                            if (res.code == 200) {
                                                that.initRenderFn();
                                                that.$message.success(res.msg, 3);
                                            } else {
                                                that.$customMessage.warning(res.msg, 3);
                                            }
                                        });
                                    },
                                })
                                return
                            }
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    this.initRenderFn();
                                    this.$message.success(res.msg, 3);
                                } else {
                                    this.$customMessage.warning(res.msg, 3);
                                }
                            });
                        }
                    }
                    if (val.type == "POPUP" && val.viewType == "SINGLE") {
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        }
                        this.QueryUpdatas = {};
                        let paramsData = [];
                        let dataValues = this.pb_selectList[0];
                        let params = {
                            gmcUid: val.pattern.gmcUid,
                            dataUid: dataValues.uid,
                            language: this.lang,
                            isChecked: false
                        };
                        this.$nextTick(() => {
                            this.$refs.popupSingleRef.openPopup();
                        });
                        ajax.post(api.POPUP, params).then(res => {
                            this.QueryUpdatas = res;
                            this.QueryUpdatas.behrUid = val.btnUid;
                        });
                    }
                    if (val.type == "POPUP" && val.viewType == "LIST") {
                        let params = {
                            btnUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            language: this.lang,
                            fieldMapUid: val.mapUid,
                            importTitle: val.name
                        };
                        params.importType = "DB";
                        params.gmcUid = val.pattern.gmcUid;
                        this.importparams = params;
                        this.importVisible = true;
                    }
                    //            弹指定弹窗
                    if(val.type == "POPUP" && val.pattern.custPage == "lookUp"){
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        }
                        let feildArr = []
                        let dataValues = this.pb_selectList[0]
                        let feildPatternParams = val.pattern.params
                        for (let ii in dataValues) {
                            for (let tt in feildPatternParams) {
                                if (ii == feildPatternParams[tt]) {
                                    feildArr.push({key: ii, value: dataValues[ii].value})
                                }
                            }
                        }
                        let params = {
                            gmcUid: this.data.gmcUid,
                            language: this.lang,
                            noEvent: true,
                            lookup: {
                                gmcUid: val.pattern.gmcUid,
                            }
                        }
                        params.feildArr = feildArr
                        this.lookupParams = params;
                        this.$refs.lookupRefs.showModal();
                    }
                    if (val.pattern.custPage == "manual" && val.type == "BUTTON") {
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let manualData = this.pb_selectList;
                        let paramsData = [];
                        for (let index in manualData) {
                            if (manualData[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = manualData[index].uid;
                                paramsData.push(paramsObj);
                            }
                        }
                        let params = {
                            gmcUid: val.pattern.gmcUid,
                            language: this.lang,
                            params: paramsData,
                            userUid: this.$route.query.userUid
                        };
                        this.manualParams = params;
                        this.$refs.manual.openModal();
                    }
                    if (val.pattern.custPage == "Cron" && val.type == "BUTTON"){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let deleteData = this.pb_selectList;
                        let paramsData = [];
                        for (let index in deleteData) {
                            paramsData.push(deleteData[index].uid)
                        }
                        ajax.post(api.ADDJOBSCHEDULE,{uids: paramsData}).then(res=>{
                            if (res.code === 200) {
                                this.$message.success(res.msg)
                            }else{
                                this.$customMessage.error(res.msg)
                            }
                        })
                    }
                    if (val.pattern.custPage == "Create Wave" && val.type == "BUTTON") {
                        this.$refs.createWaveRef.open();
                    }
                    if (val.pattern.custPage == "part-de-allocation" && val.type == "BUTTON") {
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        } else {
                            let params = [];
                            for (let ii in this.pb_selectList) {
                                params.push(this.pb_selectList[ii].uid);
                            }
                            ajax.post(api.SOHEADERALLOCAION, { uids: params }).then(res => {
                                if (res.code == 200) {
                                    this.$message.success(res.msg);
                                }
                            });
                        }
                    }
                    if (val.pattern.custPage == "Generate Location" && val.type == "BUTTON") {
                        this.$refs.generateLocationRef.open();
                    }
                    if (val.pattern.custPage == "Batch_Update" && val.type == "BUTTON") {
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let Batchdata = this.pb_selectList;
                        let batchDataArr = [];
                        for (let index in Batchdata) {
                            if (Batchdata[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = Batchdata[index].uid;
                                batchDataArr.push(paramsObj);
                                batchDataArr.push({
                                    key: "version",
                                    value: Batchdata[index].version
                                });
                            }
                        }
                        this.bathUpdatparams = {
                            gmcUid: val.pattern.gmcUid,
                            language: this.lang,
                            batchDataArr: batchDataArr,
                            btnUid: val.btnUid
                        };
                        this.$refs.bathUpdateRef.open();
                    }
                    if (val.pattern.custPage == "scanpack" && val.type == "BUTTON") {
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        } else {
                            let dataValues = this.pb_selectList[0];
                            this.$refs.scanpackRefs.show(dataValues.uid,this.data.tableList.info);
                        }
                    }
                    if(val.pattern.custPage == "scanin" && val.type == "BUTTON"){
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        } else {
                            let dataValues = this.pb_selectList[0]
                            this.$refs.scanInRefs.showIn(dataValues.uid,this.data.tableList.info)
                        }

                    }
                    if(val.pattern.custPage == "loading" && val.type == "BUTTON"){
                        this.$refs.loadingRefs.loadingShow()
                    }
                    if(val.pattern.custPage == "adjust" && val.type == "BUTTON"){
                        let params = {}
                        if(this.pb_selectList.length > 0){
                            let arr = []
                            for(let i in this.pb_selectList){
                                arr.push(this.pb_selectList[i].uid)
                            }
                            params.uids = arr
                            params.mark = val.pattern.custPage
                            this.$refs.adjust.show(this.tableGmcuid,params)
                        }else{
                            this.$refs.adjust.show(this.tableGmcuid)
                        }
                    }
                    if(val.pattern.custPage == "Move" && val.type == "BUTTON"){

                        let params = {}
                        if(this.pb_selectList.length > 0){
                            let arr = []
                            for(let i in this.pb_selectList){
                                arr.push(this.pb_selectList[i].uid)
                            }
                            params.uids = arr
                            params.mark = val.pattern.custPage
                            this.$refs.adjustMove.show('Move',params)
                        }else{
                            this.$refs.adjustMove.show('Move')
                        }
                    }
                    if(val.pattern.custPage == "Split" && val.type == "BUTTON"){
                        this.$refs.splitRef.showSplit()
                    }
                    if(val.pattern.custPage == "deliverydate" && val.type == "BUTTON"){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let deleteData = this.pb_selectList;
                        let paramsData = [];
                        for (let index in deleteData){
                            let paramsObj = {};
                            paramsObj.key = "uid";
                            paramsObj.value = deleteData[index].uid;
                            paramsData.push(paramsObj);
                        }
                        paramsData.push({key: 'moduleName', value: this.data.tableList.info})
                        let tt = {
                            behrUid: '',
                            fieldMapUid: '',
                            functionUid: '',
                            gmcUid: '',
                            language: this.lang,
                            params: paramsData,
                            type: '',
                            userUid: '',
                        }
                        this.$refs.deliveryDate.show(tt)
                    }
                    if(val.pattern.custPage == 'transfer' && val.type == 'BUTTON'){
                        let uidList = []
                        for(let i in this.pb_selectList){
                            uidList.push(this.pb_selectList[i].uid)
                        }
                        this.$refs.transfer.transferShow(uidList)
                    }
                    if(val.pattern.custPage == 'BatchUpdateShipment' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let uidList = []
                        for(let i in this.pb_selectList){
                            uidList.push(this.pb_selectList[i].uid)
                        }
                        let params = {
                            uidList: uidList.join(","),
                            subModuleCode: this.data.tableList.info,
                            gmcUid: this.tableGmcuid,
                            btnGmcUid: val.pattern.gmcUid,
                            btnUid:val.btnUid
                        }
                        this.$refs.batchShipment.show(params)
                    }
                    if(val.pattern.custPage == 'buttonConfig' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length == 1) {
                            this.$refs.buttonConfigRef.show(this.pb_selectList[0].uid)
                        }else{
                            this.$refs.buttonConfigRef.show()
                        }
                    }

                }
            },
            GETcancelImport(val) {
                this.importVisible = false;
                this.getTemplateName()
                if (val == "init") {
                    this.init("empty_temp");
                }
            },
            getBtnConfigemit(){
                this.init();
            },
            GETcancelModalVisible(val) {
                this.eddvisible = false;
                this.getTemplateName()
                if (val != "close") {
                    this.init("empty_temp");
                }
            },
            getdeliverdate(){
                this.init();
            },
            getMoveSave(){
                this.initRenderFn()
            }
        }
    };
</script>
<style lang="less">
    /*@import "https://cdn.bootcss.com/bootstrap/3.3.5/css/bootstrap.css";*/
    @import "../../assets/css/bootstrap.css";
    #queryBuilder {
        overflow: hidden;
    }
    .queryBtnSty {
        margin: 4px 0;
    }
    #skuPage {
        background: #fff;
        overflow: hidden;
        .skupage {
            overflow: hidden;
            overflow-y: auto;
        }
        .ant-collapse-content > .ant-collapse-content-box {
            padding: 0;
        }
    }
    .ant-drawer-body {
        padding: 2px;
    }
</style>
